import { render, staticRenderFns } from "./PurposeAddEditModal.vue?vue&type=template&id=66dac3c3&"
import script from "./PurposeAddEditModal.vue?vue&type=script&lang=js&"
export * from "./PurposeAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports